import { useAuth } from "@mindlercare/auth-ui";
import { useEffect } from "react";

export const useZendesk = () => {
  const { isLoggedIn } = useAuth();

  useEffect(() => {
    const zendeskLauncher = document.querySelector(
      ".zendeskLauncher",
    ) as HTMLElement;

    if (zendeskLauncher) {
      zendeskLauncher.style.display = isLoggedIn ? "flex" : "none";
    }
  }, [isLoggedIn]);
};
